import React, { useState } from "react";
import Button from "../Button";

export default function ImageUploader({ imageUrl, onChange }) {
  const [preview, setPreview] = useState(imageUrl || null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // بررسی سایز فایل (حداکثر 2MB)
      if (file.size > 2 * 1024 * 1024) {
        alert("حجم فایل باید کمتر از 2MB باشد");
        return;
      }

      // بررسی فرمت فایل
      const allowedFormats = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      if (!allowedFormats.includes(file.type)) {
        alert("فرمت فایل باید JPG, PNG یا GIF باشد");
        return;
      }

      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
      onChange && onChange(file);
    }
  };

  const handleRemoveImage = () => {
    setPreview(null);
    onChange && onChange(null);
  };

  return (
    <div className="flex flex-row items-center gap-3">
      {/* تصویر پروفایل */}
      <div className="relative w-32 h-32 rounded-full overflow-hidden border-2 border-gray-200 shadow-sm bg-gray-100 group">
        {preview ? (
          <img
            src={preview}
            alt="Profile preview"
            className="object-cover w-full h-full"
          />
        ) : (
          <div className="flex flex-col items-center justify-center w-full h-full text-gray-400 text-sm p-2 text-center">
            <svg
              className="w-8 h-8 mb-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            بدون تصویر
          </div>
        )}

        {/* Overlay برای ویرایش */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
          <label
            htmlFor="upload"
            className="bg-white text-gray-700 hover:bg-gray-50 text-sm px-3 py-2 rounded-lg cursor-pointer shadow-lg transition-all duration-200 transform scale-90 group-hover:scale-100"
          >
            تغییر تصویر
          </label>
          <input
            id="upload"
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/gif"
            onChange={handleFileChange}
            className="hidden"
          />
        </div>
      </div>

      {/* دکمه حذف + توضیح کنار هم */}
      {preview && (
        <div className="flex flex-col sm:flex-row items-center gap-2 text-center">
          <Button children={'حذف تصویر'} variant={'danger'} onClick={handleRemoveImage} className={"text-red-500 hover:text-red-600 text-sm font-medium transition-colors duration-200"}/>
          <span className="text-xs text-gray-500 leading-5">
            (فرمت‌های مجاز: JPG, PNG, GIF — حداکثر سایز: ۲MB)
          </span>
        </div>
      )}

      {/* اگه هنوز تصویری نیست */}
      {!preview && (
        <div className="text-xs text-gray-500 text-center leading-5">
          فرمت‌های مجاز: JPG, PNG, GIF — حداکثر سایز: ۲MB
        </div>
      )}
    </div>
  );
}
